"use client";

import { Search, FileText, CircleCheck } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HowItWorks() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const steps = [{
    icon: Search,
    title: "You receive a lab result",
    description: "You see a number, range or flag that isn't immediately clear.",
    ref: ref1,
    isVisible: isVisible1,
    delay: "0ms"
  }, {
    icon: FileText,
    title: "Look up the lab value",
    description: "Browse or search for the test or biomarker on this site.",
    ref: ref2,
    isVisible: isVisible2,
    delay: "80ms"
  }, {
    icon: CircleCheck,
    title: "We explain the context",
    description: "We describe what the result usually means and how doctors typically interpret it - based on evidence and without giving medical advice.",
    ref: ref3,
    isVisible: isVisible3,
    delay: "160ms"
  }];
  return <section className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <h2 className="font-display text-3xl font-bold text-foreground sm:text-4xl">
            How It Works
          </h2>
          <p className="text-muted-foreground mx-auto mt-4 max-w-2xl text-lg">
            Three simple steps to understanding your lab results with confidence
          </p>
        </div>

        <div className="relative">
          {}
          

          <div className="grid gap-8 md:grid-cols-3">
            {steps.map((step, index) => {
            const Icon = step.icon;
            return <div key={index} data-index={index} ref={step.ref} style={{
              transitionDelay: step.delay,
              opacity: step.isVisible ? 1 : 0,
              transform: step.isVisible ? "translateY(0)" : "translateY(20px)",
              transition: "opacity 150ms ease-out, transform 150ms ease-out"
            }}>
                  <Card className="relative h-full border border-border shadow-soft transition-all duration-[150ms] hover:shadow-medium">
                    <CardContent className="flex flex-col items-center pt-12 text-center">
                      {}
                      <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-lg bg-primary/10 transition-transform duration-[150ms] hover:scale-105">
                        <Icon className="h-8 w-8 text-primary" strokeWidth={2} />
                      </div>

                      {}
                      <div className="absolute -top-3 left-1/2 flex h-6 w-6 -translate-x-1/2 items-center justify-center rounded-full bg-primary text-xs font-bold text-foreground-primary">
                        {index + 1}
                      </div>

                      <h3 className="mb-3 font-display text-xl font-semibold text-foreground">
                        {step.title}
                      </h3>
                      <p className="text-muted-foreground text-sm leading-relaxed">
                        {step.description}
                      </p>
                    </CardContent>
                  </Card>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}